export default "__VITE_ASSET__3fb2f289__"